<template>
  <v-card :height="height" class="">
    <v-card-title class="grey--text text-subtitle-1">
      Ordini Attivi
      <v-btn icon @click="expand()" class="ml-4">
        <v-icon>{{
          is_expanded ? "mdi-chevron-up" : "mdi-chevron-down"
        }}</v-icon>
      </v-btn>
      <v-menu v-model="menu_filtro">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on"><v-icon>mdi-filter</v-icon></v-btn>
        </template>
        <v-list>
          <v-list-item @click="valore_filtro = -1">
            <v-list-item-avatar>
              <v-icon>mdi-filter-off</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title> Tutti </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="valore_filtro = 1">
            <v-list-item-avatar>
              <v-icon color="green">mdi-clipboard-check</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title> Confermati </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="valore_filtro = 0">
            <v-list-item-avatar>
              <v-icon color="orange">mdi-clipboard-arrow-up</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title> In Attesa </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="valore_filtro = 8">
            <v-list-item-avatar>
              <v-icon color="purple">mdi-playlist-check</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title> Conteggiato </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="valore_filtro = 6">
            <v-list-item-avatar>
              <v-icon color="blue">mdi-truck-fast</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title> In Consegna </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="valore_filtro = 7">
            <v-list-item-avatar>
              <v-icon color="indigo">mdi-package-down</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title> Consegnato </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn icon @click="filtro_pianificato = !filtro_pianificato"
        ><v-icon>{{
          filtro_pianificato ? "mdi-truck-check" : "mdi-truck-outline"
        }}</v-icon></v-btn
      >
      <v-btn icon @click="filtro_consegne = !filtro_consegne"
        ><v-icon>{{
          filtro_consegne ? "mdi-truck-delivery" : "mdi-truck-delivery-outline"
        }}</v-icon></v-btn
      >
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon small class="mr-4" v-on="on" :loading="refreshing" @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Aggiorna ordini attivi</span>
      </v-tooltip>
      <NuovoOrdine />
    </v-card-title>

    <v-card-text :class="is_expanded ? 'scroll_extended' : 'scroll'">
      <v-divider class="mb-2" />
      <v-row class="font-weight-medium" no-gutters>
        <v-col cols="1" class="pl-4"> ID </v-col>
        <v-col cols="1" class="pl-1"> Data </v-col>
        <v-col cols="3"> Cliente </v-col>
        <v-col cols="1"> Consegna </v-col>
        <v-col cols="1" class="d-flex justify-end pr-2"> Totale </v-col>
        <v-col cols="1" class="d-flex justify-end pr-6">CC</v-col>
        <v-col cols="2"> Stato </v-col>
      </v-row>
      <v-divider class="mt-2 mb-2" />
      <v-row v-if="!ordini_attivi.length" justify="center" class="pt-12">
        Nessun Nuovo Ordine
      </v-row>
      <div v-else>
        <template v-if="filtro_consegne">
          <MappaConsegna
            v-if="selected_consegna"
            :consegna="selected_consegna"
            ref="mappa_consegna"
          />
          <template v-for="consegna in ordini_attivi_consegne">
            <v-row
              :key="consegna.n_consegna"
              no-gutters
              class="py-2 pl-4 grey lighten-4"
              align="center"
            >
              <span
                class="text-decoration-underline blue--text"
                style="cursor: pointer"
                @click="open_mappa(consegna.n_consegna)"
                >Consegna: #
                {{ get_consegna(consegna.n_consegna).numero }}</span
              >
              <ConsegnaButtons :consegna="get_consegna(consegna.n_consegna)" small class="ml-4"/>
              <span v-if="get_consegna(consegna.n_consegna).archiviata" class="green--text"><b>Conclusa</b></span>
            </v-row>
            <OrdineAttivoEl
              v-for="ordine in consegna.ordini"
              :ordine="ordine"
              :key="ordine._id.$oid"
            />
          </template>
        </template>
        <template v-else>
          <OrdineAttivoEl
            v-for="ordine in ordini_attivi"
            :ordine="ordine"
            :key="ordine._id.$oid"
          />
        </template>
      </div>
    </v-card-text>
    <v-row align="center" justify="center">
      <v-btn icon color="grey" depressed @click="expand()">
        <v-icon dark>{{
          is_expanded ? "mdi-chevron-up" : "mdi-chevron-down"
        }}</v-icon>
      </v-btn>
    </v-row>
  </v-card>
</template>

<script>
import ordini_mixin from "../mixin/ordini_mixin";
import NuovoOrdine from "./crea_nuovo_ordine/crea_nuovo_ordine.vue";
import OrdineAttivoEl from "./ordine_attivo_element.vue";
import MappaConsegna from "../../Consegne/desktop/consegna_dettaglio_mappa.vue";
import ConsegnaButtons from "../../Consegne/desktop/avvia_consegna_button.vue";
export default {
  components: {
    NuovoOrdine,
    OrdineAttivoEl,
    MappaConsegna,
    ConsegnaButtons,
  },
  mixins: [ordini_mixin],
  data() {
    return {
      is_expanded: false,
      height: 390,
      selected_consegna: null,
      refreshing: false,
    };
  },
  methods: {
    refresh() {
      this.refreshing = true;
      this.$store.dispatch("fetch_ordini_attivi").finally(() => {
        this.refreshing = false;
      });
    },
    expand() {
      if (this.is_expanded) {
        this.is_expanded = false;
        this.height = 390;
      } else {
        this.is_expanded = true;
        this.height = 800;
      }
    },
    open_mappa(consegna_id) {
      this.selected_consegna = this.get_consegna(consegna_id);
      setTimeout(() => {
        this.$refs.mappa_consegna.open();
      }, 200);
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}
.scroll {
  height: 300px;
  overflow-y: scroll;
}

.scroll_extended {
  height: 710px;
  overflow-y: scroll;
}
</style>
